let isLive = false;

export const images = {
    LOADER_LOGO: require('../../assets/img/img.png'),
}

export const url = {
    BASE_URL: 'https://virtuous-sprouts-server.vercel.app'
}

export const endpoints = {
   
}

export const initialState = {
   
}

export const appSettings = {
    
}

export const terms = ['1st', '2nd', '3rd'];

export const commentType = ["Teacher's Comment", "Principal's Comment"];

export const resultType = ["Test", "Exam"];

export const subjects = [
    "Tahfeedhul Qur'an",
    "Pre-vocational Studies",
    "Basic Science and Technology",
    "Islamic Studies",
    "National Value",
    "Quantitative Reasoning",
    "Al-Arabiyyah",
    "Verbal Reasoning",
    "Al-Qiraahah Wal-Kitaabah",
    "Mathematics/Numeracy",
    "English/Literacy",
    "Creative Arts/Drawings",
    "Handwriting",
    "At-Taoheed",
    "Al-Hadith",
    "Rhymes",
    "Business Studies",
    "Social Studies",
    "Civic Education",
    "Yoruba",
    "Physical and Health Education",
    "Home Econoimics",
    "Computer Science",
    "Biology",
    "Physics",
    "Chemistry",
    "Geography",
    "Economics",
    "Financial Account",
    "Commerce",
    "Agric. Science",
    "Marketing",
    "Art",
    "Literature",
    "History",
    "Food and Nutrition",
    "Fishery",
    "Animal Husbandry",
    "Government",
    "General studies",
]
